<template>
  <footer class="wt-asset-footer wt2-sg">
    <wt-button type="transparent" text="Cancel" @click="cancel"></wt-button>
    <wt-button type="primary" text="Save & Close" @click="done"></wt-button>
  </footer>
</template>

<script>
import bus from 'v/AssetEditor/AssetEditorEventBus';

/** (GW)
 * Asset Editor's general done button
 */
export default {
  methods: {
    /**
     * Emit done event
     * caught by assetEditorView
     */
    done() {
      bus.$emit('done');
    },
    cancel() {
      bus.$emit('cancel');
    },
  },
};
</script>
